module.exports = __webpack_public_path__ + "static/media/loader.1504df2c.gif";